/**
 * Renders a schema.org JSON-LD document as a body script tag.
 *
 * Search engines treat body JSON-LD identically to head JSON-LD. Rendering
 * content-heavy graphs (ItemList, FAQPage) from the component instead of the
 * route's head() keeps the underlying content arrays inside the lazily loaded
 * route chunk instead of the shared entry bundle.
 */
export function JsonLd({ nodes }: { nodes: unknown[] }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({ "@context": "https://schema.org", "@graph": nodes })
          .replace(/</g, "\\u003c")
          .replace(/>/g, "\\u003e")
          .replace(/&/g, "\\u0026")
          .replace(/\u2028/g, "\\u2028")
          .replace(/\u2029/g, "\\u2029"),
      }}
    />
  );
}
